/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Profile = {
    id?: string;
    createdAt?: string;
    updatedAt?: string;
    mongoId?: string;
    citizenId?: string;
    passportNumber?: string;
    firstName?: string;
    lastName?: string;
    type?: Profile.type;
    citizenAddress?: string;
    currentAddress?: string;
    occupation?: string;
    workPlace?: string;
    workAddress?: string;
    email?: string;
    lineId?: string;
    facebookUrl?: string;
    facebookName?: string;
    firstReferencePersonFirstName?: string;
    firstReferencePersonLastName?: string;
    firstReferencePersonRelation?: string;
    firstReferencePersonPhoneNumber?: string;
    secondReferencePersonFirstName?: string;
    secondReferencePersonLastName?: string;
    secondReferencePersonRelation?: string;
    secondReferencePersonPhoneNumber?: string;
    instagramName?: string;
    instagramUrl?: string;
    tiktokName?: string;
    tiktokUrl?: string;
    fullName?: string;
    validCitizenId?: boolean;
};
export namespace Profile {
    export enum type {
        ONLINE = 'ONLINE',
        OFFLINE = 'OFFLINE',
    }
}

